document.getElementById('newsletter-sections--22665964749107__newsletter-popup').addEventListener('submit', function(event) {
  event.preventDefault();

  const userEmail = document.getElementById('Email-sections--22665964749107__newsletter-popup').value;
 
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(userEmail)) {
      return;
  }

  klaviyo.push(['identify', {
    'email': userEmail
  }]);

  this.submit();
});